import { Component, OnInit } from '@angular/core';
import { RevenueItemService } from '../shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../shared/revenue-items/revenue-item.model';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../shared/widgets/value-accessors/object-value-accessor';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'wl-revenue-item-multi-selector',
  templateUrl: 'revenue-item-multi-selector.component.html',
  styleUrls: ['revenue-item-multi-selector.component.css'],
  providers: [
    RevenueItemService,
    CreateObjectValueAccessorProvider(WlRevenueItemMultiSelectorComponent),
    CreateObjectValueValidationProvider(WlRevenueItemMultiSelectorComponent),
  ],
    standalone: false
})
export class WlRevenueItemMultiSelectorComponent extends ObjectValueAccessor<number[]> implements OnInit {
  //public selectedRevenueItems: Array<number>;
  public revenueItems: RevenueItem[] = [];
  public selectedRevenueItems: RevenueItem[] = [];

  public constructor(private _revenueItemService: RevenueItemService, private _route: ActivatedRoute) {
    super([], true);
  }

  /**
   * overload super class's writeValue
   */
  writeValue(value: number[]) {
    super.writeValue(value);

    if (this.value) {
      // value changed outside
      this.populateSelectedFromValue();
    }
  }

  /**
   * my initter
   */
  ngOnInit(): void {
    this.setupComponent();
  }

  /**
   * setup the component
   */
  private async setupComponent(): Promise<void> {
    try {
      // load revenue items for selector
      this.revenueItems = await this._revenueItemService.getRevenueItems();
      this.populateSelectedFromValue();

      const duesItems = (this._route.snapshot.queryParamMap.get('duesItems') ?? 'false') === 'true';
      if (duesItems) {
        this.selectedRevenueItems = [];
        this.addDuesItems();
      }

      const nonDuesItems = (this._route.snapshot.queryParamMap.get('nonDuesItems') ?? 'false') === 'true';
      if (nonDuesItems) {
        this.selectedRevenueItems = [];
        this.addNonDuesItems();
      }
    } catch (e) {
    } finally {
    }
  }

  /**
   * when user clicks the add button
   */
  public addRevenueItems(): void {
    // clone selected, ensure uniquely added
    let selectedAvailRevenueItems: RevenueItem[] = this.revenueItems
      .filter((x) => (<any>x).Selected && (!this.value || this.value.indexOf(x.ItemNum) < 0))
      .map((x) => JSON.parse(JSON.stringify(x)));

    if (!selectedAvailRevenueItems.length) return;

    this.selectedRevenueItems.forEach((x) => ((<any>x).Selected = false));

    selectedAvailRevenueItems.forEach((ri) => {
      this.selectedRevenueItems.push(ri);
    });

    // unselect the available list
    this.revenueItems.filter((x) => (<any>x).Selected).forEach((x) => ((<any>x).Selected = false));
    this.updateValue();
  }

  public addDuesItems() {
    const duesItems = this.revenueItems.filter((x) => x.DuesType);
    duesItems?.forEach((x) => {
      this.selectedRevenueItems.push(x);
    });
    this.updateValue();
  }

  public addNonDuesItems() {
    const nonDuesItems = this.revenueItems.filter((x) => !x.DuesType);
    nonDuesItems?.forEach((x) => {
      this.selectedRevenueItems.push(x);
    });
    this.updateValue();
  }

  /**
   * when user clicks remove button
   */
  public removeRevenueItems(): void {
    let removingRevenueItems: RevenueItem[] = this.selectedRevenueItems.filter((x) => (<any>x).Selected);
    this.selectedRevenueItems = this.selectedRevenueItems.filter((x) => !(<any>x).Selected);

    removingRevenueItems.forEach((x) => ((<any>x).Selected = false));

    this.updateValue();
  }

  /**
   * toggle revenue item selected toggle
   * @param revenueItem
   */
  public toggleSelected(revenueItem: RevenueItem): void {
    (<any>revenueItem).Selected = !(<any>revenueItem).Selected;
  }

  /**
   * update backing value. super class handles updating angular bindings
   */
  private updateValue(): void {
    let newValue: number[] = this.selectedRevenueItems.map((x) => x.ItemNum);
    let oldValueStr: string = JSON.stringify(this.value);
    let newValueStr: string = JSON.stringify(newValue);

    if (oldValueStr != newValueStr) super.writeValue(newValue);
  }

  /**
   * reset the selected side based on value of component (mostly in reaction to when value is changed outside this component)
   */
  private populateSelectedFromValue(): void {
    if (!this.value) return;

    this.selectedRevenueItems = this.revenueItems
      .filter((x) => this.value.indexOf(x.ItemNum) > -1)
      .map((x) => JSON.parse(JSON.stringify(x)));

    this.selectedRevenueItems.forEach((x) => ((<any>x).Selected = false));
  }
}
